// The download catalogue the Downloads page offers, as pure data.
//
// Lives in lib/ rather than in Downloads.tsx for the same reason
// detectPlatform does: the web package's vitest runs node-env over
// `src/**/*.test.ts` with no DOM, so importing the page would drag in its
// auth/react-router dependencies. Keeping the catalogue here lets
// downloadPlatforms.test.ts check it directly.
//
// Neomaris Core ships as a Debian package only: amd64 for any 64-bit
// Intel/AMD Debian or Ubuntu machine, arm64 for a Raspberry Pi.
//
// The page supplies the icon per id; this module deliberately carries no JSX.

import type { PlatformId } from './detectPlatform';

export type DownloadPlatform = {
  id: PlatformId;
  name: string;
  subtitle: string;
  /** The exact R2 object key the release publishes. */
  file: string;
};

/** What the Downloads page shows. */
export const DOWNLOAD_PLATFORMS: DownloadPlatform[] = [
  {
    id: 'linux-deb',
    name: 'Ubuntu / Debian',
    subtitle: '64-bit Intel/AMD · .deb package',
    file: 'neomaris-core_amd64.deb',
  },
  {
    id: 'linux-arm64',
    name: 'Raspberry Pi / Linux ARM',
    subtitle: '64-bit ARM · .deb package',
    file: 'neomaris-core_arm64.deb',
  },
];
